<div class="vehicle-one-section">
    <slot />
</div>

<style>
    .vehicle-one-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        column-gap: 5px;
        /*margin-right: 10px;*/
    }
</style>